import { Component, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { secureStorage } from '../shared/services/encryption/secureservice';
import { isPlatformBrowser, Location } from '@angular/common';
import { ApiService } from '../shared/services/apiService.service';
import { Subscription } from 'rxjs';
import { RootService } from '../shared/services/root.service';
import { BehaviourSubjectService } from '../shared/services/behaviour-subject.service';
import { ClevertapService } from '../shared/services/clevertap/clevertap.service';
import { WishlistService } from '../shared/services/wishlist.service';
import { HttpHeaders } from '@angular/common/http';
import { CookieService } from '../shared/services/cookie.service';
import { WebsocketService } from '../websocket.service';
@Component({
  selector: 'app-otp-popup',
  templateUrl: './otp-popup.component.html',
  styleUrls: ['./otp-popup.component.scss']
})
export class OtpPopupComponent implements OnInit {
  showModal = false;
  popupForm: FormGroup;
  otpValue: any;
  isVliadOtp: boolean = false;
  isVerify: boolean = false;
encryptData :any;
queryObject:any={};
showTick = false;
isUserLoggedIn: boolean = false;
sub: Subscription = new Subscription();
loginId: any;
showReject = false;
m: any;
s: any;
timeLeft: any;
isSendOtp:boolean=false;
count= 0
  @Input() isTimer: boolean = false;
    @ViewChild('OtpInput') OtpInputRef: any;
    @ViewChild('ngOtpInput') ngOtpInput: any;
  showLinkExpired: boolean=false;
  isSocketConnected: boolean = false;
  constructor(private fb: FormBuilder,private toastrService: ToastrService,private spinner: NgxSpinnerService,private activatedroute:ActivatedRoute,private localStorage: secureStorage,private location: Location,private router :Router,private apiService :ApiService, private storageService: RootService,private behaviourSubject: BehaviourSubjectService, @Inject(PLATFORM_ID) private platformId: Object,
private cleverService: ClevertapService,private wishlistService: WishlistService,private ssrcookieService: CookieService,private websocketService :WebsocketService) {
    this.popupForm = this.fb.group({
      otp: ['', Validators.required]
    });
  }

  ngOnInit(): void {    
    const fullUrl = this.location.path(true);
  const encryptedValue = fullUrl.split('?')[1];

  let decoded = decodeURIComponent(encryptedValue);
  decoded = decoded.replace(/ /g, '+')
  let decodedObj = this.localStorage.decryptData(decoded)

  this.queryObject = {};
  let paramsmaps = decodedObj.split("&");
                
  paramsmaps.forEach(param => {
    let [key, value] = param.split("=");
    if (key && value !== undefined) {
      this.queryObject[key] = decodeURIComponent(value);
    }
  });
  
 
  this.websocketStatus(this.queryObject?.socket_id)
  if (this.queryObject.mobile_number) {
    this.checkExpiry();
  }    
  this.count = 1
  }

   websocketStatus(data: string): void {
  try {
    let req = {
      socket_id: data
    };

    this.sub.add(
      this.apiService.socketStatus(req).subscribe({
        next: (result) => {
          if (result.success) {
            this.isSocketConnected = result.data.is_connected;
            if (!this.isSocketConnected) {
              this.LinkExpired();
            }
          } else {
            this.isSocketConnected = false;
          }
        },
        error: (err) => {
          this.isSocketConnected = false;
          console.error(err);
        },
        complete: () => {
          // Optional: handle completion if needed
        }
      })
    );
  } catch (error) {
    this.isSocketConnected = false;
    console.error(error);
  }
}


  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
    this.popupForm.reset();
  }

  onSubmit() {
    if (this.isVliadOtp) {

this.closeModal()
// this.showTick = true;

  setTimeout(() => {
    // this.showTick = false; // hide it after a delay (optional)
  }, 2000);
    }
  }
   OTPChecker(event: any) {
    this.checkTimeExpiry()
      if (event.length === 6) {
        this.otpValue = event;
        this.isVliadOtp = true;
      } else this.isVliadOtp = false;
    
    }
    onClickVerify() {
      if (this.isVerify) return;
      this.isVerify = true;
    this.checkTimeExpiry();
      if (!this.otpValue || this.otpValue.length < 6) {
        this.spinner.hide();
        this.toastrService.warning('Please enter OTP');
        this.isVerify = false;
        return;
      }
    
      const data = {
        mobile_number: this.queryObject?.mobile_number || '',
        otp_number: this.otpValue,
        socket_id: this.queryObject?.socket_id || ''
      };
    
      if (this.queryObject?.access_token) {
        this.ssrcookieService.removeItem("access_token");
        this.ssrcookieService.setItem("access_token", this.queryObject?.access_token);
      }
    
      // this.spinner.show();
    
      this.sub.add(
        this.apiService.verifyOtpWhatsApp(data).subscribe({
          next: (response: any) => {
            this.spinner.hide();
            this.isVerify = false;
    
            if (response?.success) {
              this.showTick = true;
              this.sub.add(this.websocketService.disconnect())
              this.sub.unsubscribe();

              this.showModal = false;
    
              // setTimeout(() => {

                this.isUserLoggedIn = this.storageService.isLoggedIn();
                if (this.isUserLoggedIn) {
                  this.behaviourSubject.isTataOkLogin.next(true);
                }
    

                this.storageService.loginUser(response.data);
    
                if (isPlatformBrowser(this.platformId)) {
                  try {
                    this.cleverService.onUserLogFunc(
                      response.data.first_name,
                      response.data.last_name,
                      response.data.email_id,
                      response.data.mobile_number
                    );
                    this.cleverService.onUserLogin(
                      response.data.first_name + ' ' + response.data.last_name,
                      response.data.email_id,
                      response.data.mobile_number
                    );
                  } catch {}
                }
   
                let wishList = this.wishlistService.getWishlist();
                if (wishList?.length > 0) {
                  const saved = JSON.parse(localStorage.getItem('wishlist') || '[]');
                  this.addToWishlist(saved);
                }

              // }, 1500); 
            } else if(response?.data?.msg === 'Link expired please request a new link.'){
              this.LinkExpired()
            }else {
       
              this.showReject = true;
              this.showTick =false;
              this.showModal = false;
    
              setTimeout(() => {
                this.showReject = false;
                this.toastrService.warning(response?.data?.msg || 'OTP Invalid');
                this.showModal = true;
                this.isVliadOtp = false;
              }, 1500);
            }
          },
          error: () => {
            this.spinner.hide();
            this.closeModal()
            this.isVerify = false;
            this.showReject = true;
            this.showModal = false;
    
            // setTimeout(() => {
              this.showReject = false;
              this.toastrService.warning(
                'Your account is locked due to multiple incorrect OTP. Please try after sometime'
              );
              this.showModal = true;
            // }, 1500);
          },
          complete: () => {
            this.spinner.hide();
          }
        })
      );
    }
    
   vasCount(value) {
    const signup = JSON.parse(this.localStorage.getItem("signup")) ? true : false;
    let data = {
      "mobile_number": value,
      'source': signup ? 'Web Registration' : 'Web Login'
    }
    this.apiService.get_amc_consent_view(data).subscribe((res) => {
    })
  }
  addToWishlist(event: any) {
    let data = {
      product: event,
      action_type: 'add',
    };
    this.sub.add(
      this.apiService.addToWishlist(data).subscribe({
        next: (res: any) => {
          localStorage.removeItem('wishlist');
        },
        error: () => { },
        complete: () => { },
      })
    );
  }
  startTimer(timeLeft: any) {
    this.timeLeft = timeLeft;
    const interval = setInterval(() => {
      this.isTimer = true;
      this.m = Math.floor(this.timeLeft / 60);
      this.s = this.timeLeft % 60;
      this.m = this.m < 10 ? '0' + this.m : this.m;
      this.s = this.s < 10 ? '0' + this.s : this.s;
      this.timeLeft--;
      if (this.timeLeft < 0) {
        this.isTimer = false;
        clearInterval(interval);
      }
    }, 1000);
  }
  resendOTP() {
    if(this.count === 1){
     this.ngOtpInput.setValue('');
      this.otpValue = '';
      if (this.OtpInputRef) {
        this.OtpInputRef.setValue('');
      }
      this.sentOtp(this.queryObject.mobile_number);
      this.startTimer(120);
      this.count = 0
    }else{
      if (!this.isTimer && this.timeLeft <= 0) {
      this.ngOtpInput.setValue('');
      this.otpValue = '';
      if (this.OtpInputRef) {
        this.OtpInputRef.setValue('');
      }
      this.sentOtp(this.queryObject.mobile_number);
      this.startTimer(120);
    }
    }
   
  }
  sentOtp(mobile_number){
    this.spinner.show();
    let data = {
      mobile_number: mobile_number,
      action_type: 'login',
    };
    this.sub.add(
      this.apiService.sentOtp1(data).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.toastrService.success(response.data.msg);
            this.spinner.hide();
            this.startTimer(120);
            // this.mobile_no.emit(this.mobileNo);
            // this.commonService.mobileNo = this.mobileNo;
            this.behaviourSubject.loginNumber.next(true)
            this.localStorage.setItem("loginNumber", JSON.stringify(mobile_number))
            localStorage.removeItem("signup")


            // this.router.navigate(['/otp/']);
            if (isPlatformBrowser(this.platformId)) {
              window.scroll(0, 0);
            }
          }
          else {
                this.toastrService.warning(response.data.msg);
                this.spinner.hide();
              }
        },
        error: () => {
          this.toastrService.warning('Something went wrong!');
          this.spinner.hide();
        },
        complete: () => { },
      })
    );
  }
  LinkExpired(){
    this.showModal = false;
    this.showTick = false;
    this.showReject = false;
    this.showLinkExpired = true;
  }
  checkExpiry() {
    const currentTime = Math.floor(Date.now() / 1000); // current time in seconds

  
    if (currentTime > this.queryObject?.expires_at) {
      // expired
     this.LinkExpired();
    } else {
      this.openModal();
      // this.sentOtp(this.queryObject.mobile_number);
    }
  }
  checkTimeExpiry() {
    const currentTime = Math.floor(Date.now() / 1000); // current time in seconds
    if (currentTime > this.queryObject?.expires_at) {
      // expired
     this.LinkExpired();
     return;
    } 
  }

  ngOnDestroy(): void {
     this.sub.unsubscribe()
  }
}
